import script from "./DocumentViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentViewer.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentViewer.vue?vue&type=style&index=0&id=93d5a498&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93d5a498"]])

export default __exports__